import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSessionToken } from "../utils/auth";
import { useCartUI } from "../context/CartUIContext";

export default function BottomNav() {
  const location = useLocation();
  const cookieValue = getSessionToken();
  const count = useSelector((state) => state.product.data);
  const { cartOpen, openCart } = useCartUI();
  const [navHidden, setNavHidden] = useState(false);

  // Hide the bottom nav whenever the shared cart panel is open, regardless of
  // whether it was opened from here or from the desktop Header cart button.
  useEffect(() => {
    setNavHidden(cartOpen);
  }, [cartOpen]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <>
      <nav className={`mob-bottom-nav${navHidden ? " mob-bottom-nav--hidden" : ""}`}>
        <Link to="/" className={`mob-bn-item${isActive("/") ? " mob-bn-item--active" : ""}`}>
          <span className="mob-bn-icon">
            <i className={`fas fa-home`}></i>
          </span>
          <span className="mob-bn-label">Home</span>
        </Link>

        <Link to="/categories" className={`mob-bn-item${isActive("/categories") ? " mob-bn-item--active" : ""}`}>
          <span className="mob-bn-icon">
            <i className="fas fa-th-large"></i>
          </span>
          <span className="mob-bn-label">Categories</span>
        </Link>

        <Link to="/search" className={`mob-bn-item${isActive("/search") ? " mob-bn-item--active" : ""}`}>
          <span className="mob-bn-icon">
            <i className="fas fa-search"></i>
          </span>
          <span className="mob-bn-label">Search</span>
        </Link>

        <button className="mob-bn-item mob-bn-cart" onClick={openCart}>
          <span className="mob-bn-icon">
            <i className="fas fa-shopping-bag"></i>
            {count?.length > 0 && (
              <span className="mob-bn-badge">{count.length}</span>
            )}
          </span>
          <span className="mob-bn-label">Cart</span>
        </button>

        <Link
          to={cookieValue ? "/profile" : "/login"}
          className={`mob-bn-item${isActive("/profile") || isActive("/login") ? " mob-bn-item--active" : ""}`}
        >
          <span className="mob-bn-icon">
            <i className={`fas ${cookieValue ? "fa-user-circle" : "fa-user"}`}></i>
          </span>
          <span className="mob-bn-label">{cookieValue ? "Profile" : "Login"}</span>
        </Link>
      </nav>
    </>
  );
}
